import styled from "styled-components";

import { Box } from "@similarweb/ui-components";

import { GROWTH_OVERVIEW_QUERY_KEY } from "./const";
import { GrowthOverviewProvider } from "./context/GrowthOverviewProvider";
import { GrowthOverviewTable } from "./table/GrowthOverviewTable";

const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: fit-content;
    margin-bottom: 24px;
`;

const GrowthOverviewContent = () => (
    <Container data-automation={`${GROWTH_OVERVIEW_QUERY_KEY}-container`}>
        <GrowthOverviewTable />
    </Container>
);

export const GrowthOverview = () => (
    <GrowthOverviewProvider>
        <GrowthOverviewContent />
    </GrowthOverviewProvider>
);
